import { makeStyles } from '@material-ui/core/styles';

export const useTestTypesListPanelStyles = makeStyles((theme) => ({
    cardListContainer: {
        padding: theme.spacing(2),
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(2.5),
        alignContent: 'flex-start',
        overflowY: 'auto',
    },
    cardListItem: {
        margin: 0,
        width: 360,
        flexBasis: 'auto',
        flexGrow: 0,
        flexShrink: 0,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        color: theme.palette.panel.contrastText,
        backgroundColor: theme.palette.panel.main,
        border: `1px solid ${theme.palette.type === 'dark' ? theme.palette.divider : 'rgba(0, 0, 0, 0.12)'}`,
    },
    cardHeaderTitle: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1),
    },
    cardHeaderTextWrap: {
        marginLeft: theme.spacing(2),
        minWidth: 0,
        lineHeight: 1.2,
    },
    cardTitleText: {
        fontSize: 20,
        fontWeight: 300,
        lineHeight: 1.2,
        display: 'inline',
    },
    cardBadge: {
        marginLeft: theme.spacing(3),
        verticalAlign: 'middle',
        height: 8,
    },
    cardBadgeAnchor: {
        display: 'inline-block',
        width: 1,
        height: 1,
    },
    cardDescription: {
        color: theme.palette.type === 'dark' ? theme.palette.panel.contrastText : theme.palette.text.secondary,
        fontSize: 13,
        lineHeight: 1.5,
        whiteSpace: 'pre-line',
        paddingBottom: theme.spacing(5),
    },
    supportingText: {
        color: theme.palette.type === 'dark' ? theme.palette.panel.contrastText : theme.palette.text.secondary,
        overflow: 'hidden',
        lineHeight: 1.5,
        fontSize: 13,
        whiteSpace: 'pre-line',
        width: '90%',
        paddingBottom: '16px',
        '& .subTitle': {
            marginBottom: '10px',
            '& i': {
                fontSize: '15px',
                paddingRight: '10px',
            },
        },
        '& .MuiSvgIcon-root': {
            fontSize: 14,
            color: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
        },
    },
    convertedScriptMessage: {
        textAlign: 'left',
        padding: '0px 40px 0px 0px',
        position: 'relative',
        top: 24,
    },
    convertedScriptMessageIcon: {
        color: theme.palette.warning.main,
    },
    convertedScriptMessageText: {
        position: 'relative',
        left: 30,
        top: -24,
    },
    grow: {
        flexGrow: 1,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        gap: theme.spacing(0.3),
    },
    cardActions: {
        padding: theme.spacing(0.75, 1.5, 1.25),
    },
    actionButton: {
        padding: 0,
        color: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.primary.light,
        '& .MuiSvgIcon-root': {
            fontSize: 18,
        },
    },
    gotoButton: {
        minWidth: 0,
        marginLeft: theme.spacing(1),
        padding: theme.spacing(0.25, 0),
        fontSize: 13,
        lineHeight: 1.5,
    },
    gotoButtonLabel: {
        display: 'flex',
        alignItems: 'center',
        minWidth: 0,
        whiteSpace: 'nowrap',
    },
    gotoButtonEndIcon: {
        marginLeft: theme.spacing(0.5),
        '& .MuiSvgIcon-root': {
            fontSize: 18,
        },
    },
    gotoButtonText: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 260,
    },
}));
